import React, { useEffect, useRef, useState } from 'react';

import FilterItem from './filters/FilterItem.js';
import { action } from '../lib/actionHelpers.js';
import { useHandleClickOutside, usePrevProps } from '../hooks';
import { useSelector } from 'react-redux';
import getMessageIcon from '../lib/getMessageIcon.js';
import selectors from '../selectors/selectors.js';
import filterDefinitions from './filters/lib/filterDefinitions.js';
import SVG from '../images/svg/SVG.js';

const Filters = ({ filters = [] }) => {
  const isMobile = useSelector(selectors.mobile);
  const filterValues = useSelector((state) => state.ui.filters);

  const prevFilters = usePrevProps(filters);
  const filterIconRef = useRef(null);
  const filterDropdownRef = useRef(null);
  const [filterDropdownActive, setFilterDropdownActive] = useState(false);

  useHandleClickOutside(filterDropdownRef, () => {
    setFilterDropdownActive(false);
  });

  const allFilters = filters
    .filter((n) => n.show !== false)
    .map((n) => {
      const defaultsMatch = filterDefinitions[n.type] || {};
      return { ...defaultsMatch, ...n };
    })
    .map((n) => ({
      ...n,
      pinned: isMobile ? !!filterValues[n.type || n.id] : n.pinned,
      onChange: !isMobile
        ? n.onChange
        : () => {
            setFilterDropdownActive(false);
            if (n.onChange) {
              n.onChange();
            }
          },
    }));
  const pinnedFilters = allFilters.filter((n) => (n.pinned === true || filterValues[n.id || n.type]) && n.type !== 'search');
  const otherFilters = allFilters.filter((n) => n.pinned !== true && !filterValues[n.id || n.type] && n.type !== 'search');
  const searchFilter = allFilters.find((n) => n.type === 'search');

  useEffect(() => {
    if (JSON.stringify((prevFilters || []).map((n) => n.type)) !== JSON.stringify((filters || []).map((n) => n.type))) {
      filters.forEach((n) => {
        const id = n.id || n.type;
        if (n.defaultValue && filterValues[id] !== n.defaultValue && !filterValues[id]) {
          action('uiPatchFilters', { [id]: n.defaultValue });
        }
      });
    }
  }, [filters]);

  const handleFilterIconClick = () => {
    setFilterDropdownActive(!filterDropdownActive);
  };

  if (isMobile) {
    return (
      <div className={`filters`}>
        <div className={`pinned-filters`}>
          {searchFilter && (
            <div className={'search-filter-row'}>
              <FilterItem item={searchFilter} />
              {otherFilters.length && <img className={'filter-icon'} src={getMessageIcon('filter')} alt={''} onClick={handleFilterIconClick} ref={filterIconRef} />}
            </div>
          )}
          {pinnedFilters.length > 0 && (
            <div className={'pinned-filter-row'}>
              {pinnedFilters.map((item, i) => {
                return <FilterItem key={i} item={item} />;
              })}
            </div>
          )}
        </div>
        {otherFilters.length > 0 && (
          <div className={`dropdown ${filterDropdownActive ? 'active' : ''}`} ref={filterDropdownRef}>
            {otherFilters.map((item, i) => {
              return <FilterItem key={i} item={item} />;
            })}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`filters`}>
      <div className={`pinned-filters`}>
        {pinnedFilters.map((item, i) => {
          return <FilterItem key={i} item={item} />;
        })}
      </div>
      {otherFilters.length > 0 && (
        <div className={`unpinned-filters`}>
          <button className={`filter-item-btn unpinned btn`}>
            <SVG icon={'Filters'} basic={true} />
          </button>
          <div className={`dropdown`}>
            {otherFilters.map((item, i) => {
              return <FilterItem key={i} item={item} />;
            })}
          </div>
        </div>
      )}
      <div className={`pinned-filters`}>{searchFilter && <FilterItem item={searchFilter} />}</div>
    </div>
  );
};

export default Filters;
